import axiosInstanceNew from "../lib/axiosinstanceNew";

const ReferalModel = class {
  constructor() {
    this.staticData = [
      {
        id: 1,
        name: "Rahul Sharma",
        mobile: "+91-9876543210",
        referral_wallet: 2500,
        referral_income: 1500,
        invited_referral: 8,
        request_date: "2024-11-01",
        request_amount: 1500,
        pay_amount: 1500,
        pay_date: "2024-11-05",
        status: "Approved",
        screen_shot: "screenshot_001.jpg",
        transaction_id: "TXN20241105001",
        upi_id: "rahul.sharma@upi",
        created_at: "2024-11-01T10:00:00Z",
        updated_at: "2024-11-05T14:30:00Z",
      },
      {
        id: 2,
        name: "Priya Patel",
        mobile: "+91-9876543213",
        referral_wallet: 1800,
        referral_income: 1200,
        invited_referral: 6,
        request_date: "2024-11-03",
        request_amount: 1200,
        pay_amount: 1200,
        pay_date: "2024-11-07",
        status: "Approved",
        screen_shot: "screenshot_002.jpg",
        transaction_id: "TXN20241107002",
        upi_id: "priya.patel@upi",
        created_at: "2024-11-03T09:15:00Z",
        updated_at: "2024-11-07T11:45:00Z",
      },
      {
        id: 3,
        name: "Amit Kumar",
        mobile: "+91-9876543216",
        referral_wallet: 3200,
        referral_income: 0,
        invited_referral: 12,
        request_date: "2024-10-28",
        request_amount: 2000,
        pay_amount: null,
        pay_date: null,
        status: "Pending",
        screen_shot: null,
        transaction_id: null,
        upi_id: "amit.kumar@upi",
        created_at: "2024-10-28T14:20:00Z",
        updated_at: "2024-10-28T14:20:00Z",
      },
      {
        id: 4,
        name: "Sneha Gupta",
        mobile: "+91-9876543219",
        referral_wallet: 950,
        referral_income: 950,
        invited_referral: 4,
        request_date: "2024-10-25",
        request_amount: 950,
        pay_amount: 950,
        pay_date: "2024-10-30",
        status: "Approved",
        screen_shot: "screenshot_004.jpg",
        transaction_id: "TXN20241030004",
        upi_id: "sneha.gupta@upi",
        created_at: "2024-10-25T16:45:00Z",
        updated_at: "2024-10-30T13:15:00Z",
      },
      {
        id: 5,
        name: "Vikram Singh",
        mobile: "+91-9876543222",
        referral_wallet: 2100,
        referral_income: 0,
        invited_referral: 9,
        request_date: "2024-11-02",
        request_amount: 1800,
        pay_amount: null,
        pay_date: null,
        status: "Declined",
        screen_shot: "screenshot_005.jpg",
        transaction_id: "TXN20241102005",
        upi_id: "vikram.singh@upi",
        created_at: "2024-11-02T12:30:00Z",
        updated_at: "2024-11-04T10:00:00Z",
      },
      {
        id: 6,
        name: "Anjali Desai",
        mobile: "+91-9876543225",
        referral_wallet: 2750,
        referral_income: 0,
        invited_referral: 11,
        request_date: "2024-11-04",
        request_amount: 1600,
        pay_amount: null,
        pay_date: null,
        status: "Pending",
        screen_shot: null,
        transaction_id: null,
        upi_id: "anjali.desai@upi",
        created_at: "2024-11-04T08:45:00Z",
        updated_at: "2024-11-04T08:45:00Z",
      },
      {
        id: 7,
        name: "Rohan Mehta",
        mobile: "+91-9876543228",
        referral_wallet: 1400,
        referral_income: 1400,
        invited_referral: 5,
        request_date: "2024-10-30",
        request_amount: 1400,
        pay_amount: 1400,
        pay_date: "2024-11-03",
        status: "Approved",
        screen_shot: "screenshot_007.jpg",
        transaction_id: "TXN20241103007",
        upi_id: "rohan.mehta@upi",
        created_at: "2024-10-30T11:20:00Z",
        updated_at: "2024-11-03T15:30:00Z",
      },
    ];
  }

  async List() {
    // Return static data instead of API call
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: this.staticData,
          meta: {
            current_page: 1,
            per_page: 20,
            total_page: 1,
            total: this.staticData.length,
          },
        });
      }, 500);
    });
  }
  async Listbystate(id) {
    // Return filtered static data
    return new Promise((resolve) => {
      setTimeout(() => {
        let filteredData = this.staticData;
        if (id && id !== "All") {
          filteredData = this.staticData.filter((item) => item.status === id);
        }
        resolve({
          data: filteredData,
          meta: {
            current_page: 1,
            per_page: 20,
            total_page: 1,
            total: filteredData.length,
          },
        });
      }, 300);
    });
  }
  async Mark(id, data = []) {
    // Simulate update
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true, message: "Status updated successfully" });
      }, 500);
    });
  }
};

export default new ReferalModel();
